import { UserPermission } from '../../__generated__/graphql'

export type AdgroupBudgetPermissionKey =
  | 'adgroupBudgetCapping'
  | 'adgroupMonthlyBudgetCapping'
  | 'adgroupOverallBudgetCapping'
  | 'adgroupOpenBudgetCapping'
  | 'adgroupOpenDailyBudget'

export type AdgroupCostPermissionKey = 'adgroupCpm' | 'adgroupCpl'

export const ADGROUP_COST_PERMISSION_KEYS: AdgroupCostPermissionKey[] = ['adgroupCpm', 'adgroupCpl']

export const ADGROUP_BUDGET_CAPPING_PERMISSION_KEYS: AdgroupBudgetPermissionKey[] = [
  'adgroupMonthlyBudgetCapping',
  'adgroupOverallBudgetCapping',
  'adgroupOpenBudgetCapping',
]

/** Always allowed; shown as locked in company budget capping rights (no API permission field). */
export const ADGROUP_BUDGET_CAPPING_LOCKED_LABEL_KEYS = ['company.rights.adgroupPeriodBudgetCapping'] as const

export type AdgroupBudgetUserPermissions = Pick<UserPermission, AdgroupBudgetPermissionKey>

export type AdgroupCostUserPermissions = Pick<UserPermission, AdgroupCostPermissionKey>
